import { INSTANCE_URL, FILES_URL } from '../../Common/constant';
import {
  deleteRequest,
  getRequest,
  postRequest,
  patchRequest,
  uploadEncodedFile
} from '../../Common/network-call';
import { fetchAndFilterByBookMark } from '../../../actions';
import _ from 'lodash';

export const FETCH_CHALLENGES = 'FETCH_CHALLENGES';
export const FETCH_LEADERBOARD = 'FETCH_LEADERBOARD';
export const SHOWPOPUP_MODAL = 'SHOWPOPUP_MODAL';
export const CERTIFICATE_MODAL = 'CERTIFICATE_MODAL';

export const fetchChallenges = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/gamification_script/achievements`;
  var body = {
    eventid: `${session.eventid}`,
    userid: `${session.userid}`
  };
  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        //console.log('response.data', response.data);
        let gameData = [];
        if (response.data && response.data.length > 0) {
          _.map(response.data, obj => {
            obj.displayorder = parseInt(obj.displayorder);
            gameData.push(obj);
          });
          const sortedData = _.orderBy(gameData, ['displayorder'], ['asc']);
          //console.log('sortedData', sortedData);
          dispatch({
            type: FETCH_CHALLENGES,
            payload: { data: sortedData }
          });
          callback({ success: 1 });
        } else {
          dispatch({
            type: FETCH_CHALLENGES,
            payload: { data: [] }
          });
          callback({ success: 0 });
        }
      },
      error => {
        //callback({success: 0, error: error});
      }
    );
  };
};

export const challengesEmpty = callback => {
  return dispatch => {
    dispatch({
      type: FETCH_CHALLENGES,
      payload: {}
    });
    callback({ success: 1 });
  };
};

export const leaderBoardEmpty = callback => {
  return dispatch => {
    dispatch({
      type: FETCH_LEADERBOARD,
      payload: {}
    });
    callback({ success: 1 });
  };
};

export const fetchLeaderboards = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/gamification_script/leaderboard`;
  var body = {
    eventid: `${session.eventid}`,
    userid: `${session.userid}`
  };
  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        dispatch({
          type: FETCH_LEADERBOARD,
          payload: { data: response.data, userstats: response.userstats }
        });
        callback({ success: 1 });
      },
      error => {
        //callback({success: 0, error: error});
      }
    );
  };
};

export const challengeStatus = (session, challengetype, callback) => {
  var url = `${INSTANCE_URL}/api/v2/gamification_script/challenge_status`;
  var body = {
    eventid: `${session.eventid}`,
    userid: `${session.userid}`,
    challengetype: `${challengetype}`
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, data: response.resource });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const showpopupModal = (showModal = false, item = {}) => {
  return dispatch => {
    dispatch({
      type: SHOWPOPUP_MODAL,
      payload: {
        showModal: showModal,
        item: item
      }
    });
  };
};

export const pointCredited = (session, challengetype, userid, callback) => {
  var url = `${INSTANCE_URL}/api/v2/gamification_script/challenge_status`;
  var body = {
    eventid: `${session.eventid}`,
    userid: `${userid}`,
    challengetype: `${challengetype}`
  };
  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // dispatch({
        //   type: FETCH_LEADERBOARD,
        //   payload: { data: response.data, userstats: response.userstats }
        // });
        callback({ success: 1, data: response.resource });
      },
      error => {
        //callback({success: 0, error: error});
      }
    );
  };
};

export const openRewardModal = (showModal = false, awardimg = '') => {
  return dispatch => {
    dispatch({
      type: CERTIFICATE_MODAL,
      payload: {
        showModal: showModal,
        awardimg: awardimg
      }
    });
  };
};
